import React from 'react'
import styled from 'styled-components'
import ServiceCard from '../../components/ServiceCard'
import Responsive from '../../assets/config/Responsive'
import Colors from '../../assets/styles/Colors'
import { useAppDispatch, useAppSelector } from '../../store'
import { SliceType, clearCompanyInfo, setProductType } from '../../store/businessSlice'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import carIcon from '../../assets/img/business-icons/carIcon.svg'
// @ts-ignore
import healthIcon from '../../assets/img/business-icons/healthIcon.svg'
// @ts-ignore
import propertyIcon from '../../assets/img/business-icons/propertyIcon.svg'
// @ts-ignore
import otherIcon from '../../assets/img/business-icons/otherIcon.svg'
import { useNavigate } from 'react-router-dom'

const BusinessCategory = () => {
  //
  const dispatch = useAppDispatch()
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const { productType } = useAppSelector((data: { business: SliceType }) => data.business)
  //

  // product categories object
  const productCategories = [
    {
      productType: 'health',
      title: `${t('healthInsurance')}`,
      body: `${t('healthBusinessDescription')}`,
      image: `${healthIcon}`,
    },
    {
      productType: 'car',
      title: `${t('carInsurance')}`,
      body: `${t('carBusinessDescription')}`,
      image: `${carIcon}`,
    },
    {
      productType: 'property',
      title: `${t('propertyInsurance')}`,
      body: `${t('propertyBusinessDescription')}`,
      image: `${propertyIcon}`,
    },
    {
      productType: 'other',
      title: `${t('other')}`,
      body: `${t('otherBusinessDescription')}`,
      image: `${otherIcon}`,
    },
  ]

  return (
    <Wrapper>
      <InfoBlock>
        <InfoTitle>{t('categoryTitle')}</InfoTitle>
        <CardWrapper>
          {productCategories.map((item, index) => {
            return (
              <ServiceCard
                key={index}
                to={
                  item.productType === 'health'
                    ? '/health-company-info'
                    : item.productType === 'car'
                    ? '/car-company-info'
                    : item.productType === 'property'
                    ? '/property-company-info'
                    : item.productType === 'other'
                    ? '/other-company-info'
                    : '/business-category'
                }
                onClick={() => [
                  navigate(
                    item.productType === 'health'
                      ? '/health-company-info'
                      : item.productType === 'car'
                      ? '/car-company-info'
                      : item.productType === 'property'
                      ? '/property-company-info'
                      : item.productType === 'other'
                      ? '/other-company-info'
                      : '/business-category',
                  ),
                  item.productType !== productType && dispatch(setProductType(item.productType)),
                  item.productType !== productType && dispatch(clearCompanyInfo()),
                ]}
                disabled={false}
                hideMinPrice={true}
                img={item.image}
                itemTitle={item.title}
                itemBody={item.body}
                itemType={item.productType}
                arrow={false}
                showButton={false}
              />
            )
          })}
        </CardWrapper>
      </InfoBlock>
    </Wrapper>
  )
}

export default BusinessCategory

const Wrapper = styled.div`
  padding: 80px 0px;
  background-color: ${Colors.backgroundGrey};
  min-height: 100vh;
`
const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 60px;
  ${Responsive.mobile} {
    gap: 30px;
  }
`
const InfoTitle = styled.h3`
  font-size: 36px;
  font-weight: bold;
  color: ${Colors.primaryBlack};
  line-height: 40px;
  ${Responsive.mobile} {
    font-size: 18px;
    line-height: 20px;
  }
`
const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 400px);
  gap: 50px;
  ${Responsive.tablet} {
    grid-template-columns: repeat(2, 350px);
  }
  ${Responsive.mobile} {
    grid-template-columns: repeat(auto-fit, minmax(270px, 335px));
  }
`
